import $api from "@/zapi-frontend/shared/api/axios";

export async function postGenerateClaims({ projectId, chapterId }: { projectId: number; chapterId: number }) {
  const projectChapterId = chapterId;
  const response = await $api.post<{ generationId: number }>(`/claims`, { projectId, projectChapterId });
  return response.data;
}
